import type { HighlightAdapter } from '../highlight-adapter.js'
import type {
  SelectableFeatureRef,
  BackcountryTrailRef,
  BackcountryPOIRef,
} from '../selectable-feature-ref.js'
import { backcountryOverlayService } from '../../backcountry/backcountry-overlay-service.js'

/** Highlights selected OSM/backcountry features by rendering their captured
 *  geometry (the service owns the overlay source/layers). */
export class BackcountryAdapter implements HighlightAdapter {
  readonly sources = ['backcountry-trail', 'backcountry-poi']

  applyHighlights(refs: SelectableFeatureRef[]): void {
    const mine = refs.filter(
      (r): r is BackcountryTrailRef | BackcountryPOIRef =>
        r.source === 'backcountry-trail' || r.source === 'backcountry-poi'
    )
    backcountryOverlayService.highlightSelection(mine)
  }

  clearHighlights(): void {
    backcountryOverlayService.clearSelectionHighlight()
  }
}
